import React, {Component} from 'react';
import {Query} from 'react-apollo';
import gql from 'graphql-tag';
import {compose} from 'redux';
import {connect} from 'react-redux';
import RecommendedPropertyCarouselWrapper from './recommended-properties-carousel';


const recommendedProperties = gql `
    query recommendations($listingIds: [String]!, $currency: String!, $withDates: Boolean!, $stay: StayDates, $maxProperties: Int) {
        recommendations(listingIds: $listingIds, stay: $stay, maxProperties: $maxProperties) {
            status
            availableForDates
            averagePrice {
                currencySymbol
                currencyUnits
                localized
                periodType
                value
            }
            priceSummary(currency: $currency) @include(if: $withDates) {
                formattedAmount
                pricePeriodDescription
                edapEventJson
            }
            bathrooms {
                full
                half
                toiletOnly
            }
            instantBookable
            bedrooms
            sleeps
            headline
            listingId
            unitApiUrl
            detailPageUrl
            reviewCount
            averageRating
            images {
                c6_uri
            }
        }
    } `;

const mapStateToProps = ({system: {currency = ''}}) => ({
    currency
});

export class RecommendedPropertyProvider extends Component {
    render() {
        const {listingIds, stay, currency, boardId, maxProperties} = this.props;
        if (!listingIds || listingIds.length === 0) {
            return null;
        }
        const hasDates = !!(stay && stay.dateRange && stay.dateRange.arrival && stay.dateRange.departure);

        return (
            <Query query={recommendedProperties} errorPolicy="all" variables={{listingIds, currency, stay: stay.dateRange, withDates: hasDates, maxProperties}}>
                {({data, loading}) => {
                    if (loading) {
                        return null;
                    }
                    const filteredData = data && data.recommendations && data.recommendations.filter((listing) => listing && listing.status !== 'DELISTED' && listing.listingId) || [];
                    return (
                        <RecommendedPropertyCarouselWrapper boardId={boardId} recommendations={filteredData} stay={stay}/>
                    );
                }}
            </Query>
        );
    }
}
export default compose(connect(mapStateToProps))(RecommendedPropertyProvider);



// WEBPACK FOOTER //
// ./src/universal/tripboard/recommended-properties/components/recommended-properties-provider.js